import UserSharedService from '../../../respona_api/generated/user-shared_pb_service';

const service = (function () {
  let instance = null;

  return {
    getInstance: (): UserSharedService.UserSharedApiServiceClient => {
      if (!instance) {
        // @ts-ignore
        instance = new UserSharedService.UserSharedApiServiceClient(API_HOST);
      }

      return instance;
    },
  };
})();

export default service;
